module.exports = __webpack_public_path__ + "img/pic3.e3f07308.png";